<template>
  <a-card :bordered="false">
    <a-row :gutter="20">
      <a-col :span="6">
        <!-- 查询区域 -->
        <!--    <div class="table-page-search-wrapper">-->
        <!--      <a-form layout="inline" @keyup.enter.native="searchQuery">-->
        <!--        <a-row :gutter="24">-->

        <!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
        <!--            <a-form-item label="配置json">-->
        <!--              <a-input placeholder="请输入配置json" v-model="queryParam.setting"></a-input>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->

        <!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
        <!--            <a-form-item label="CODE">-->
        <!--              <a-input placeholder="请输入CODE" v-model="queryParam.code"></a-input>-->
        <!--            </a-form-item>-->
        <!--          </a-col>-->

        <!--            <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
        <!--                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">-->
        <!--                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>-->
        <!--                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>-->
        <!--                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>-->
        <!--                </span>-->
        <!--          </a-col>-->
        <!--        </a-row>-->
        <!--      </a-form>-->
        <!--    </div>-->

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :customRow="customRowFn"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :loading="loading"
            class="j-table-force-nowrap"
            >
<span slot="check" slot-scope="text, record" >
                <a-radio :checked="record.id===current.id "></a-radio>
              </span>
          </a-table>
        </div>
      </a-col>
      <a-col :span="18">
        <temp-config-base-settings-item-person v-if="current.code=='PERSON'" :setting="current" @submit="settingsSubmit"></temp-config-base-settings-item-person>
      </a-col>
    </a-row>
  </a-card>

</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TempConfigBaseSettingsItemPerson from '@views/tempconfig/baseSettings/TempConfigBaseSettingsItemPerson.vue'

  export default {
    name: "TempConfigBaseSettingsList",
    mixins:[JeecgListMixin],
    components: {
      TempConfigBaseSettingsItemPerson,
    },
    data () {
      return {
        description: '知识库-基础配置管理页面',
        // 表头
        columns: [
          {
            title: '',
            dataIndex: 'action2',
            width:35,
            align:"center",
            scopedSlots: { customRender: 'check' },
          },
		   {
            title: '名称',
            align:"center",
            dataIndex: 'name'
           },
        ],
		url: {
          list: "/tempconfig/tempConfigBaseSettings/list",
       },
        current:{}
    }
  },
  computed: {
  },
    methods: {
      settingsSubmit(){
        this.loadData()
      },
      loadDataCallback(){
        if(this.dataSource.length>0){
          if( !this.current.id ){
            this.current = this.dataSource[0]
          }else{
            this.dataSource.forEach(item=>{
              if(this.current.id === item.id){
                this.current = item
              }
            })
          }
        }
      },
      customRowFn(record) {
        return {
          on: {
            click: () => {
              this.current = record
            }
          }
        }
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>